import Action from './action';

const initialState = {
    registrationTime: null,
    errorText: '',
};

export default (state = initialState, action: {type: string, playload: {id: number, name: string}}) => {
    switch (action.type) {
        case Action.UPDATE_REGISTRATION_TIME: {
            return {
                ...state,
                registrationTime: action.playload
            }
        }
        case Action.UPDATE_REGISTRATION_TIME_ERROR_TEXT: {
            try {
                action.playload && (window as any).mailStats.show('registration_time_error', { errorText: action.playload })
            } catch(e) {}
            return {
                ...state,
                errorText: action.playload
            }
        }
        default: return state;
    }
}
